export default "__VITE_ASSET__0fef7af4__"